import { useParams, Link, Navigate } from "react-router-dom";
import { NavProductData } from "./NavProductData";

function ServicePage() {
  const { id } = useParams();

  const service = NavProductData[id];

  if (!service) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="max-w-7xl mx-auto px-6 py-12">

      <h1 className="text-4xl font-bold">
        {service.title}
      </h1>

      <p className="mt-6 text-gray-600 text-lg">
        {service.description}
      </p>

      <div className="mt-10">
        <h2 className="text-2xl font-semibold mb-4">
          What We Offer
        </h2>

        <ul className="grid md:grid-cols-2 gap-4">
          {service.features.map((feature, index) => (
            <li
              key={index}
              className="bg-gray-100 p-4 rounded-lg shadow-sm"
            >
              ✔ {feature}
            </li>
          ))}
        </ul>
      </div>

    </div>
  );
}

export default ServicePage;